import { render, staticRenderFns } from "./AllProd.vue?vue&type=template&id=71d0895b"
import script from "./AllProd.vue?vue&type=script&lang=js"
export * from "./AllProd.vue?vue&type=script&lang=js"
import style0 from "./AllProd.vue?vue&type=style&index=0&id=71d0895b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports